import { Navigate, Route, Routes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useApp } from './context/AppContext';
import { RegionPage } from './pages/RegionPage';
import { SignInPage } from './pages/SignInPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { HomePage } from './pages/HomePage';
import { SettingsPage } from './pages/SettingsPage';
import { MicrosoftOAuthCallbackPage } from './pages/MicrosoftOAuthCallbackPage';
import { AdminPage } from './pages/AdminPage';
import { BillingResultPage } from './pages/BillingResultPage';
import { AppSumoActivationPage } from './pages/AppSumoActivationPage';

function LoadingScreen({ message = 'Loading Nudge…' }) {
  return (
    <Box minHeight="100vh" display="grid" sx={{ placeItems: 'center', textAlign: 'center' }}>
      <Box>
        <CircularProgress />
        <Box sx={{ mt: 2, color: 'text.secondary', fontWeight: 700 }}>{message}</Box>
      </Box>
    </Box>
  );
}

function StartRoute() {
  const { state } = useApp();
  if (!state.authReady || (state.user && !state.initialAppLoaded)) return <LoadingScreen message="Loading your Nudge account…" />;
  if (!state.region) return <Navigate to="/region" replace />;
  if (!state.user) return <Navigate to="/signin" replace />;
  if (!state.onboardingComplete) return <Navigate to="/setup" replace />;
  return <Navigate to="/home" replace />;
}

function SignedInRoute({ children }) {
  const { state } = useApp();
  if (!state.authReady || (state.user && !state.initialAppLoaded)) return <LoadingScreen message="Loading your Nudge account…" />;
  if (!state.user) return <Navigate to="/signin" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/appsumo/activate" element={<AppSumoActivationPage />} />
      <Route path="/admin" element={<SignedInRoute><AdminPage /></SignedInRoute>} />
      <Route path="/" element={<StartRoute />} />
      <Route path="/billing/success" element={<SignedInRoute><BillingResultPage status="success" /></SignedInRoute>} />
      <Route path="/billing/cancel" element={<SignedInRoute><BillingResultPage status="cancel" /></SignedInRoute>} />
      <Route path="/region" element={<RegionPage />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/setup" element={<SignedInRoute><OnboardingPage /></SignedInRoute>} />
      <Route path="/home" element={<SignedInRoute><HomePage /></SignedInRoute>} />
      <Route path="/settings" element={<SignedInRoute><SettingsPage /></SignedInRoute>} />
      <Route path="/oauth/microsoft/callback" element={<SignedInRoute><MicrosoftOAuthCallbackPage /></SignedInRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
